import { render, staticRenderFns } from "./KnownActionDetailPage.vue?vue&type=template&id=6d676cc6&"
import script from "./KnownActionDetailPage.vue?vue&type=script&lang=js&"
export * from "./KnownActionDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports